import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination } from 'swiper/modules';
import Tab from '../Tab/Tab';
import { Tab as TabListItem, Tabs as ReactTabs, TabList, TabPanel } from 'react-tabs';
import useTabs from '@/hooks/useTabs';
import { StyledTabTitle, StyledContent, StyledTabs } from './Tabs.styles';

const Tabs = ({
  hasWhiteBackground,
  items,
}: {
  items: Queries.TABBED_BLOCKFragment['tabbedBlockElements']['tabs']['value'];
  hasWhiteBackground: boolean;
}) => {
  const { activeIndex, setActiveIndex } = useTabs({ numberOfItems: items.length });

  return (
    <StyledTabs>
      <ReactTabs forceRenderTabPanel onSelect={() => {}} selectedIndex={activeIndex}>
        <TabList>
          <Swiper
            slideToClickedSlide={true}
            slidesPerView={'auto'}
            spaceBetween={24}
            grabCursor={true}
            freeMode={true}
            modules={[FreeMode, Pagination]}
          >
            {items.map((item, index) => (
              <SwiperSlide onClick={() => setActiveIndex(index)} key={item.system.id}>
                <TabListItem tabIndex={(index + 1).toString()}>
                  <StyledTabTitle
                    isActive={activeIndex === index}
                    data-text={item.elements.tab_headline.value}
                  >
                    {item.elements.tab_headline.value}
                  </StyledTabTitle>
                </TabListItem>
              </SwiperSlide>
            ))}
          </Swiper>
        </TabList>

        {items.map((item, index) => (
          <TabPanel key={item.system.id}>
            <StyledContent isActive={activeIndex === index}>
              <Tab {...item} hasWhiteBackground={hasWhiteBackground} />
            </StyledContent>
          </TabPanel>
        ))}
      </ReactTabs>
    </StyledTabs>
  );
};

export default Tabs;
